module.exports = __webpack_public_path__ + "img/LW.2195066a.png";